var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 25.8333V28.1667H16.5V25.8333H9.5ZM9.5 11.8333V14.1667H21.1667V11.8333H9.5ZM21.1667 30.5V28.1667H30.5V25.8333H21.1667V23.5H18.8333V30.5H21.1667ZM14.1667 16.5V18.8333H9.5V21.1667H14.1667V23.5H16.5V16.5H14.1667ZM30.5 21.1667V18.8333H18.8333V21.1667H30.5ZM23.5 16.5H25.8333V14.1667H30.5V11.8333H25.8333V9.5H23.5V16.5Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.d08854c3f59d3f7311bfad93ac61b87f.svg";
export { ForwardRef as ReactComponent };